import React from "react";
import { fmtNumber } from "../lib/utils";
import { Building2, GitMerge } from "lucide-react";

const APPROACH_LABEL = {
  equity_share: "Equity Share",
  operational: "Operational Control",
  financial: "Financial Control",
};

export default function EntityConsolidationCard({ data }) {
  if (!data || !data.rows?.length) return null;
  const savings = data.total_raw - data.total_consolidated;
  const savingsPct = data.total_raw > 0 ? (savings / data.total_raw) * 100 : 0;

  return (
    <div className="card p-4" data-testid="entity-consolidation-card">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="section-label flex items-center gap-2">
            <GitMerge size={12}/> Row-by-row consolidation by site
          </div>
          <div className="text-xs text-ink-soft mt-0.5">
            Approach: <span className="font-semibold">{APPROACH_LABEL[data.approach] || data.approach}</span> · Period {data.period} · each Site's emissions are scaled by its owning Company's consolidation factor.
          </div>
        </div>
        <div className="text-right">
          <div className="dlabel">Raw → Consolidated</div>
          <div className="font-mono text-sm mt-0.5">
            <span className="text-ink-soft">{fmtNumber(data.total_raw)}</span>
            <span className="mx-1 text-ink-soft">→</span>
            <span className="font-semibold text-brand" data-testid="ec-total-consolidated">{fmtNumber(data.total_consolidated)}</span>
            <span className="text-[10px] text-ink-soft ml-1">tCO₂e</span>
          </div>
          {savings > 0 && (
            <div className="text-[10px] text-ink-soft">
              −{fmtNumber(savings, 2)} tCO₂e ({savingsPct.toFixed(1)}%) excluded by consolidation
            </div>
          )}
        </div>
      </div>

      <table className="dense w-full mt-3">
        <thead>
          <tr>
            <th>Site</th>
            <th>Owning company</th>
            <th className="text-right">Ownership %</th>
            <th className="text-right">Factor</th>
            <th className="text-right">Raw tCO₂e</th>
            <th className="text-right">Consolidated tCO₂e</th>
            <th className="text-right">Rows</th>
          </tr>
        </thead>
        <tbody>
          {data.rows.map((r) => {
            const scaled = r.consolidation_factor < 0.999;
            return (
              <tr key={r.entity_id} data-testid={`ec-row-${r.entity_id}`}>
                <td>
                  <div className="flex items-center gap-2">
                    <Building2 size={11} className="text-ink-soft"/>
                    <span className="font-medium">{r.site_name}</span>
                  </div>
                </td>
                <td className="text-[11px] text-ink-soft">{r.owning_company || "—"}</td>
                <td className="num">{r.ownership_pct != null ? `${r.ownership_pct}%` : "—"}</td>
                <td className="num">
                  <span className={"font-mono " + (scaled ? "text-amber-600 font-semibold" : "text-ink-soft")}>
                    {(r.consolidation_factor * 100).toFixed(1)}%
                  </span>
                </td>
                <td className="num text-ink-soft">{fmtNumber(r.raw_co2e)}</td>
                <td className="num font-semibold">{fmtNumber(r.consolidated_co2e)}</td>
                <td className="num text-[11px] text-ink-soft">{r.rows}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
